import { Link, View } from "@react-pdf/renderer"
import { Style } from "@react-pdf/types/style"
import { colors } from "../../config/theme"
import Text from "./Text"

const Footer = ({ style }: { style?: Style }) => (
  <View
    fixed
    style={{
      ...style,
      flex: 0,
      paddingBottom: 35,
    }}
  >
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignSelf: "stretch",
      }}
    >
      <Link src="https://www.belimo.com/contact" wrap>
        <Text
          style={{
            fontSize: 12,
            lineHeight: 14,
            color: colors.greyDark,
          }}
        >
          belimo.com/contact
        </Text>
      </Link>
      <Text
        style={{
          fontSize: 12,
          lineHeight: 14,
          color: colors.greyDark,
        }}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
      />
    </View>
  </View>
)

export default Footer
